import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const HowToOrderRoot = styled('div', {
    width: '100%',
    background: '$accent-white',
    padding: '$8 $2',

    '@bp2': {
        padding: '48px $2 94px',
    }
})

export const HowToOrderContainer = styled('div', {

})

export const HowToOrderFlex = styled('div', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '$7',
    flexDirection: 'column',

    '@bp2': {
        gap: '$2',
        flexDirection: 'row',
    },

    '@bp3': {
        gap: '$7',
    }
})

export const Column = styled('div', {
    background: '$tertiary-200',
    borderRadius: '20px',
    border: '1px solid $accent-black',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '$1',
    padding: '$3',
    maxWidth: '361px',

    '& > button': {
        marginTop: '$2',
    },

    '@bp2': {
        maxWidth: '440px',
        padding: '$6',
        gap: '$3',

        '& > button': {
            marginTop: '0',
        },
    },

    '@bp3': {
        maxWidth: '550px',
    }
})

export const Title = styled(Text, {
    width: '100%',
    margin: 'auto',
    marginBottom: '$5',
})

export const CardTitle = styled('h3', {
    fontSize: '$h5',
    letterSpacing: '$h5',
    lineHeight: '$h5',
    textAlign: 'center',

    '@bp2': {
        fontSize: '$h2',
        letterSpacing: '$h2',
        lineHeight: '$h2',
    }
})